<style lang='stylus'scoped>
.rightH {
  .demonstration {
    color: #999;
    font-size: 18px;
    margin-right: 15px;
  }
}
</style>

<template>
  <div class="rightH">
    <span class="demonstration">统计月份</span>
    <el-date-picker v-model="monTime" type="month" placeholder="选择月" @change="changeTime"></el-date-picker>
    <el-button v-show="hideExport" style="margin-left:15px;">导出</el-button>
  </div>
</template>
<script>
import { hideExport } from '@/utils/tools'
export default {
  
  props: {
    monTime: {
      default: new Date(),
      type: [Object, String]
    },
    changeTime: {
      default: () => {},
      type: Function
    }
  },
    data() {
      return {
       hideExport:hideExport,
      }
    },
}
</script>